import { Eyebrow } from './eyebrow';

/**
 * White ground, hairline border, 12px radius, optional provenance footer.
 * `projected` switches to the dashed amber treatment the concept reserves for
 * anything that was not measured.
 */
export const CoachCard: React.FC<{
  title?: string;
  provenance?: string;
  projected?: boolean;
  className?: string;
  testId?: string;
  children: React.ReactNode;
}> = ({ title, provenance, projected = false, className = '', testId, children }) => (
  <div
    data-testid={testId}
    className={`flex flex-col gap-3 rounded-lg bg-card p-5 ${
      projected ? 'projected-frame' : 'border border-border'
    } ${className}`}
  >
    {title && <Eyebrow tone={projected ? 'projected' : 'muted'}>{title}</Eyebrow>}
    {children}
    {provenance && (
      <div className="border-t border-border pt-2.5 text-[10.5px] leading-relaxed text-muted-foreground">
        {provenance}
      </div>
    )}
  </div>
);
